/**
 * Wörterzeile des Kapitels „Kanäle & Werbeflächen" (vorschlag_v3 §3.3/§4.1). Seit Stufe 0 des P1/P2-Umbaus (E7.1)
 * der kapitelübergreifende Baustein mit der P3-Wortliste (`WOERTERZEILE.kanaele`, dieselben Sätze in derselben
 * Reihenfolge wie vorher) und demselben Speicherschlüssel.
 */
import { FC } from 'react';
import WoerterzeileKapitel from '../../../components/auswertungen/Woerterzeile';

const Woerterzeile: FC = () => <WoerterzeileKapitel kapitel="kanaele" />;

export default Woerterzeile;
